import React from "react";
import { LoaderCircle, Earth } from "lucide-react";
import AnimatedProgressCircle from "./AnimatedProgressCircle";
import KyvaIcon from "../../icons/kyva";

const MessageBoxLoading = ({
  analyzing,
  browsing,
}: {
  analyzing: boolean;
  browsing: boolean;
}) => {
  const getStateText = () => {
    if (analyzing) return "Analyzing";
    if (browsing) return "Browsing Internet";
    return "Thinking";
  };

  const LoadingIndicator = () => {
    if (browsing) {
      return (
        <div className="pl-2">
          <Earth className="animate-[spin_3s_linear_infinite] h-5 w-5 text-violet-500" />
        </div>
      );
    }
    return <AnimatedProgressCircle analyzing={analyzing} />;
  };

  return (
    <>
      <div className="flex items-center">
        <div className="flex items-center">
          <div className="relative w-10 h-10">
            <svg className="w-full h-full" viewBox="0 0 100 100">
              <circle
                className="text-gray-400 stroke-current"
                strokeWidth="2"
                cx="50"
                cy="50"
                r="48"
                fill="transparent"
              />
            </svg>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <KyvaIcon width="24" height="24" />
            </div>
          </div>
          <div className="pl-2 pt-1 font-semibold">Kyva</div>
        </div>
        <LoaderCircle className="animate-spin ml-2 mt-2" size={20} />
      </div>

      <div className="flex items-center text-sm">
        <div className="pr-2 font-semibold text-gray-800 flex items-center">
          <span className="inline-flex mr-2">
            <LoadingIndicator />
          </span>
          {getStateText()}
          <span className="inline-flex ml-2">
            <span className="animate-[ping_1s_ease-in-out_infinite] h-2 w-2 rounded-full bg-gray-500 mr-1"></span>
            <span className="animate-[ping_1s_ease-in-out_0.333s_infinite] h-2 w-2 rounded-full bg-gray-500 mr-1"></span>
            <span className="animate-[ping_1s_ease-in-out_0.666s_infinite] h-2 w-2 rounded-full bg-gray-500"></span>
          </span>
        </div>
      </div>
    </>
  );
};

export default MessageBoxLoading;
